import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareCtx = createContext(null);
export const MAX_COMPARE = 4;

export function CompareProvider({ children }) {
  const [ids, setIds] = useState(() => JSON.parse(localStorage.getItem("compare") || "[]"));
  useEffect(() => localStorage.setItem("compare", JSON.stringify(ids)), [ids]);
  const has = (id) => ids.includes(id);
  const toggle = (id, fullMsg) => {
    if (!ids.includes(id) && ids.length >= MAX_COMPARE) { toast.error(fullMsg); return; }
    setIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : prev.length >= MAX_COMPARE ? prev : [...prev, id]));
  };
  const remove = (id) => setIds((prev) => prev.filter((x) => x !== id));
  const clear = () => setIds([]);
  return <CompareCtx.Provider value={{ ids, has, toggle, remove, clear }}>{children}</CompareCtx.Provider>;
}

export const useCompare = () => useContext(CompareCtx);
